module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title",
    attrs: {
      "id": "fm-2"
    }
  }, [_vm._v("Abbreviations")]), _vm._v(" "), _c('p', {
    staticClass: "para"
  }, [_vm._v("Only abbreviations not currently found in the "), _c('em', [_vm._v("SBL Handbook of Style")]), _vm._v(" are included here.")]), _vm._v(" "), _c('table', {
    staticClass: "table1"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "width1"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Arab. Arch. Epig.")])])]), _vm._v(" "), _c('td', {
    staticClass: "width2"
  }, [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Arabian Archaeology and Epigraphy")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("AUSDDS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Andrews University Seminary Doctoral Dissertation Series")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("CSB")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Christian Standard Bible")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("EAnth")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Encyclopedia of Anthropology")]), _vm._v(". 5 vols. Ed. H. James Birx. Thousand Oaks, CA: Sage, 2006.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ECNT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Exegetical Commentary on the New Testament")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("ETS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Evangelical Theological Society")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("EXB")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Expanded Bible")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("GW")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("GOD’S WORD Translation")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("ISV")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("International Standard Version")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("KEL")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Kregel Exegetical Library")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("LEB")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lexham English Bible")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("LGRB")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Lives of Great Religious Books")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("MBI")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Methods in Biblical Interpretation")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NCV")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("New Century Version")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("NEASB")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("Near East Archaeology Society Bulletin")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NOG")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Names of God Bible")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("OEBI")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('em', [_vm._v("The Oxford Encyclopedia of Biblical Interpretation.")]), _vm._v(" Ed. Steven L. McKenzie. Oxford: Oxford University Press, 2013.")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("PHSC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Perspectives on Hebrew Scriptures and Its Contexts")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SBEC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studies in the Bible and Early Christianity")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("SRA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Studies in Religion and the Arts")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("TatC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Texts @ Contexts")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "t-left"
  }, [_c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("YLT")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "t-left"
  }, [_vm._v("Young’s Literal Translation")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-019af3b7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/008_Abbreviations.vue
// module id = 78
// module chunks = 0